import type { PermissaoUsuario } from '@/types/PermissaoUsuario'

export const usePermissaoStore = defineStore('permissaoStore', {
  state: () => ({
    listaDePermissoes: [] as PermissaoUsuario[],
    pagination: { // Add pagination state
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 15,
    },
    permitirEdicaoCompetenciaFechada: false,
  }),

  getters: {
    // Getter para verificar se usuário pode configurar a trava
    podeConfigurarTravaCompetencia: () => {
      const usuario = useUsuarioStore().usuarioAtual.usuario
      const cartorio = useUsuarioStore().usuarioAtual.cartorio
      return usuario?.admin === 'S' ||
             cartorio?.usuario_funcao === 'titular' || cartorio.permissoes
        .some(permissao => permissao.excluir === 1 && permissao.especialidade_nome === 'financeiro')
    },
  },
  actions: {
    async fetchListaDePermissoes () {
      try {
        const response = await useApiStore().request('/financeiro/permissao', { method: 'GET' })
        console.log('Permissões recebidas:', response)
        this.listaDePermissoes = Array.isArray(response) ? response : response.data
      } catch (error) {
        console.error('Erro ao buscar lista de permissões:', error)
      }
    },
    async updatePermissao (permissao: PermissaoUsuario) {
      try {
        const updatedPermissao = await useApiStore().request<PermissaoUsuario>(`/financeiro/permissao/${permissao.id}`, {
          method: 'PUT',
          body: {
            inserir: permissao.inserir,
            editar: permissao.editar,
            excluir: permissao.excluir,
            visualizar: permissao.visualizar,
          },
        })
        // Update the local list
        const index = this.listaDePermissoes.findIndex(p => p.id === updatedPermissao.id)
        if (index !== -1) {
          this.listaDePermissoes[index] = updatedPermissao
        }
        // Optionally show success notification
      } catch (error) {
        console.error('Erro ao atualizar permissão:', error)
        // Handle error appropriately
      }
    },

    async buscarConfiguracaoTravaCompetencia () {
      try {
        const response = await useApiStore().request('/financeiro/configuracoes/trava-competencia', {
          method: 'GET',
        })
        this.permitirEdicaoCompetenciaFechada = response?.permitir_edicao || false
      } catch (error) {
        console.error('Erro ao buscar configuração de trava:', error)
        // Mantém padrão restritivo em caso de erro
        this.permitirEdicaoCompetenciaFechada = false
      }
    },

    async salvarConfiguracaoTravaCompetencia (permitir: boolean) {
      try {
        await useApiStore().request('/financeiro/configuracoes/trava-competencia', {
          method: 'PUT',
          body: {
            permitir_edicao: permitir,
          },
        })
        this.permitirEdicaoCompetenciaFechada = permitir

        useStore().toasts.push({
          content: 'Configuração salva com sucesso',
          color: 'success',
        })
      } catch (error) {
        console.error('Erro ao salvar configuração:', error)
        useStore().toasts.push({
          content: 'Erro ao salvar configuração',
          color: 'danger',
        })
      }
    },
  },
})
